var map = {
	"./az/resources-768.jpg": "2442",
	"./be/resources-768.jpg": "c548",
	"./en/resources-768.jpg": "e1eb",
	"./et/resources-768.jpg": "cd80",
	"./hy/resources-768.jpg": "e2a5",
	"./ka/resources-768.jpg": "d7bc",
	"./kk/resources-768.jpg": "29f1",
	"./ky/resources-768.jpg": "befe",
	"./lt/resources-768.jpg": "7f04",
	"./lv/resources-768.jpg": "dc69",
	"./mn/resources-768.jpg": "108f",
	"./ru/resources-768.jpg": "5de7",
	"./uz/resources-768.jpg": "2a40"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "878b";